import React, { useEffect, useState } from "react";

const NAV = [
  { id: "the-book", label: "The Book" },
  { id: "the-thirty", label: "The Thirty" },
  { id: "what-you-get", label: "What You Get" },
  { id: "whos-behind", label: "Who's Behind It" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-cream/90 backdrop-blur-md hair-bottom" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto container-x flex items-center justify-between h-16 lg:h-20">
        <a
          href="#top"
          data-testid="brand-mark"
          className="font-display text-xl sm:text-2xl tracking-tight text-ink"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          We Gotta <span className="italic text-gold-bright">Gift</span>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => scrollTo(item.id)}
              className="text-[11px] uppercase tracking-[0.22em] font-medium text-ink-soft hover:text-burgundy transition-colors"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="header-apply"
            onClick={() => scrollTo("apply")}
            className="bg-ink text-cream px-5 py-2.5 text-[11px] uppercase tracking-[0.22em] font-medium hover:bg-burgundy transition-colors duration-300"
          >
            Apply Now
          </button>
          <button
            data-testid="nav-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 text-ink"
            aria-label="Toggle menu"
          >
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.4">
              {open ? (
                <>
                  <path d="M4 4 L18 18" />
                  <path d="M18 4 L4 18" />
                </>
              ) : (
                <>
                  <path d="M3 6 L19 6" />
                  <path d="M3 11 L19 11" />
                  <path d="M3 16 L19 16" />
                </>
              )}
            </svg>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-cream hair-bottom hair-top">
          <div className="container-x py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                className="text-left text-[12px] uppercase tracking-[0.22em] font-medium text-ink-soft hover:text-burgundy"
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
